import { Component,  OnInit, signal } from '@angular/core';
import { BaseEntityComponent } from '@bndes/bndes-ux4/bndes-angular-utils';
import { CicloDistribuicaoDto } from 'src/app/model/ciclo-distribuicao-dto.model';
import { DistribuicaoLimitesService } from '../distribuicao-limites.service';
import { DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { BnMaskDirective } from '@bndes/bndes-ux4/bn-mask/bn-mask-directive';
import { DistribuicaoAgentesComponent } from '../distribuicao-agentes/distribuicao-agentes.component';


@Component({
  selector: 'app-distribuicao-limites-detalhes',
  imports: [
    DatePipe,
    FormsModule,
    BnMaskDirective,
    DistribuicaoAgentesComponent
  ],
  templateUrl: './distribuicao-limites-detalhes.component.html',
  styleUrl: './distribuicao-limites-detalhes.component.scss',
  standalone: true,
})
export class DistribuicaoLimitesDetalhesComponent extends BaseEntityComponent<CicloDistribuicaoDto> implements OnInit {

  public ciclo = signal<CicloDistribuicaoDto | null>(null);
  public page?: Number;
  public pageSize?: Number;
  public atributoOrdenacao?: String;
  public sentidoOrdenacao?: 'asc' | 'desc';


  constructor(
    private distribuicaoLimitesService: DistribuicaoLimitesService
  ) {
    super(distribuicaoLimitesService);
  }

  ngOnInit(): void {
    this.page ??= history.state.page;
    this.pageSize ??= history.state.pageSize;
    this.atributoOrdenacao ??= history.state.atributoOrdenacao;
    this.sentidoOrdenacao ??= history.state.sentidoOrdenacao;
    if (history.state.ciclo) {
      // Abertura inicial: usa objeto disponivel
      this.ciclo.set(history.state.ciclo);
    } else {
      // Fallback se página for carregada por url
      const id = Number(this.route.snapshot.paramMap.get('id'));
      this.distribuicaoLimitesService.findById(id).subscribe(ciclo => {
        this.ciclo.set(ciclo);
        console.log(this.ciclo)
      });
    }
  }

  voltar() {
    const queryParams = Object.fromEntries(Object.entries({
      page: this.page,
      pageSize: this.pageSize,
      atributoOrdenacao: this.atributoOrdenacao,
      sentidoOrdenacao: this.sentidoOrdenacao
    }).filter(([_, value]) => value != null));
    this.router.navigate(['/distribuicao-limites-configuracao'], { 
      queryParams
    });
  }
}
